import { defineFurniture } from './types.js';

/** The original kopitiam set. Prices are in Kaki Dollars. */
export const CORE_FURNITURE = {
  ...defineFurniture('kopitiam', {
    counter: {
      label: 'Kopi Counter',
      description: 'Stand next to it to order a drink.',
      price: 400,
      solid: true,
      service: true,
      height: 1,
    },
    counter_white: {
      label: 'Kopi Counter (White)',
      description: 'Stand next to it to order a drink.',
      price: 400,
      solid: true,
      service: true,
      height: 1,
    },
    counter_black: {
      label: 'Kopi Counter (Black)',
      description: 'Stand next to it to order a drink.',
      price: 400,
      solid: true,
      service: true,
      height: 1,
    },
    coffee_machine: {
      label: 'Coffee Machine',
      description: 'Hisses, gurgles, and pours a mean kopi.',
      price: 600,
      solid: true,
      service: true,
      height: 1.4,
    },
    table_round: {
      label: 'Marble Table',
      description: 'The classic round kopitiam table.',
      price: 200,
      solid: true,
      height: 0.9,
    },
    table_round_white: {
      label: 'White Marble Table',
      description: 'The classic round kopitiam table.',
      price: 200,
      solid: true,
      height: 0.9,
    },
    table_round_black: {
      label: 'Black Marble Table',
      description: 'The classic round kopitiam table.',
      price: 200,
      solid: true,
      height: 0.9,
    },
  }),
  ...defineFurniture('seating', {
    stool: {
      label: 'Kopitiam Stool',
      description: 'Wobbly, round, iconic.',
      price: 80,
      solid: false,
      seat: 'free',
      height: 0.5,
    },
    chair: {
      label: 'Plastic Chair',
      description: 'Stackable. Unbreakable. Probably.',
      price: 100,
      solid: false,
      seat: 'facing',
      height: 0.5,
    },
    chair_blue: {
      label: 'Plastic Chair (Blue)',
      description: 'Stackable. Unbreakable. Probably.',
      price: 100,
      solid: false,
      seat: 'facing',
      height: 0.5,
    },
    chair_black: {
      label: 'Plastic Chair (Black)',
      description: 'Stackable. Unbreakable. Probably.',
      price: 100,
      solid: false,
      seat: 'facing',
      height: 0.5,
    },
    armchair: {
      label: 'Cosy Armchair',
      description: 'For long chats over teh tarik.',
      price: 300,
      solid: false,
      seat: 'facing',
      height: 0.5,
    },
    armchair_green: {
      label: 'Cosy Armchair (Green)',
      description: 'For long chats over teh tarik.',
      price: 300,
      solid: false,
      seat: 'facing',
      height: 0.5,
    },
    armchair_navy: {
      label: 'Cosy Armchair (Navy)',
      description: 'For long chats over teh tarik.',
      price: 300,
      solid: false,
      seat: 'facing',
      height: 0.5,
    },
    bean_bag: {
      label: 'Bean Bag',
      description: 'Squishy. Nobody ever gets up.',
      price: 250,
      solid: false,
      seat: 'free',
      height: 0.35,
    },
    bean_bag_green: {
      label: 'Bean Bag (Green)',
      description: 'Squishy. Nobody ever gets up.',
      price: 250,
      solid: false,
      seat: 'free',
      height: 0.35,
    },
    bean_bag_yellow: {
      label: 'Bean Bag (Yellow)',
      description: 'Squishy. Nobody ever gets up.',
      price: 250,
      solid: false,
      seat: 'free',
      height: 0.35,
    },
  }),
  ...defineFurniture('decor', {
    plant: {
      label: 'Potted Palm',
      description: 'Adds a touch of green.',
      price: 150,
      solid: true,
      height: 1.6,
    },
    lamp: {
      label: 'Standing Lamp',
      description: 'Warm light for late suppers.',
      price: 200,
      solid: true,
      height: 2,
    },
    rug: {
      label: 'Batik Rug',
      description: 'Soft underfoot. Walk right over it.',
      price: 120,
      solid: false,
      height: 0,
    },
    bookshelf: {
      label: 'Bookshelf',
      description: 'Old comics and a lost umbrella.',
      price: 350,
      solid: true,
      height: 2,
    },
    fan: {
      label: 'Standing Fan',
      description: 'Essential in this weather.',
      price: 180,
      solid: true,
      height: 1.4,
    },
  }),
  ...defineFurniture('fun', {
    jukebox: {
      label: 'Jukebox',
      description: 'Pick a song and queue it up. Everyone in the room takes turns.',
      price: 800,
      solid: true,
      height: 1.6,
      interaction: { type: 'jukebox' },
    },
    arcade: {
      label: 'Arcade Cabinet',
      description: 'High score: KOPIKING. Click to play the arcade games.',
      price: 900,
      solid: true,
      height: 1.8,
      interaction: { type: 'arcade' },
    },
  }),
};
